import { formatKstDateTime } from "@sobidogam/domain";
import { useState } from "react";
/** The browser picker remains editable; the visible value is always Korean. */
export function KoreanDateTimeField({
	value,
	onChange,
	disabled = false,
}: {
	value: string;
	onChange: (value: string) => void;
	disabled?: boolean;
}) {
	const [editing, setEditing] = useState(false);
	return (
		<span className="korean-datetime">
			<button
				className="quiet-button"
				type="button"
				disabled={disabled}
				aria-expanded={editing}
				onClick={() => setEditing(!editing)}
			>
				{formatKstDateTime(`${value}:00+09:00`)} · 바꾸기
			</button>
			<input
				hidden={!editing}
				type="datetime-local"
				aria-label="날짜와 시각 바꾸기"
				value={value}
				disabled={disabled}
				onChange={(event) => onChange(event.target.value)}
			/>
		</span>
	);
}
